import React from 'react';
import { Menu, MenuItem, MenuList, MenuPopover, MenuTrigger } from '@fluentui/react-components';
import { ArrowClockwise16Regular, ErrorCircle16Filled } from '@fluentui/react-icons';
import { AiOutlineLoading3Quarters } from 'react-icons/ai';
import styles from './css/index.module.css';

const FileIndexStatus = ({ isIndexing, isFailed, onRetry }) => {
    if (isIndexing) {
        return (
            <AiOutlineLoading3Quarters
                className={`rotateLoader ${styles.indexingSpinner}`}
                title="Indexing for AI"
                aria-label="Indexing for AI"
            />
        );
    }

    if (!isFailed) return null;

    return (
        <Menu positioning="below-start">
            <MenuTrigger disableButtonEnhancement>
                <button
                    type="button"
                    className={styles.indexingFailedTrigger}
                    onClick={event => event.stopPropagation()}
                    aria-label="Indexing failed. Open retry options"
                    title="Indexing failed">
                    <ErrorCircle16Filled className={styles.indexingFailedIcon} />
                </button>
            </MenuTrigger>
            <MenuPopover onClick={event => event.stopPropagation()}>
                <MenuList>
                    <MenuItem icon={<ArrowClockwise16Regular />} onClick={onRetry}>
                        Retry indexing
                    </MenuItem>
                </MenuList>
            </MenuPopover>
        </Menu>
    );
};

export default FileIndexStatus;
